import React from "react";
import Glyph from "@/bit/components/components.icon-glyph";
import CustomLink from "@/bit/components/components.custom-link";
import Text, { TEXT_SIZE, TEXT_COLOR } from "@/bit/components/components.text";

const StoreLink = ({ infolink }) => {
  let glyph;

  switch (infolink["Icon"].id) {
    case "cheuron-right":
    default:
      glyph = <Glyph {...infolink["Icon"]} id="cheuron-right" />;
  }

  return (
    <>
      <CustomLink
        {...infolink}
        taggingInfo={{
          ...infolink.taggingInfo,
          componentName: "devicesSectionFree",
          componentContent: "ver-todo",
          eventType: "click",
        }}
        cyData="DeviceSection StoreLink"
      >
        <Text
          text={infolink["label"]}
          size={TEXT_SIZE.BODY1}
          color={TEXT_COLOR.BLUE}
          cyData="DeviceSection StoreLink Text"
        />
        {glyph}
      </CustomLink>
      <style jsx>
        {`
          .store-link {
            display: flex;
            flex-flow: row nowrap;
            align-items: center;
            gap: 0.375rem;

            & > :global(.svg-layout-size) {
              transition: transform 200ms ease-in-out;
            }

            &:hover {
              & > :global(.svg-layout-size) {
                transform: translateX(0.5rem);
              }
            }
          }
        `}
      </style>
    </>
  );
};

export default StoreLink;
